<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/cloud/title-image-cloud-computing.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Cloud"
      subheading="Limitless Horizons for Transforming the Business"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
      relatedTitle="RELATED CAPABILITIES"
      :paragraphContent="paragraphContent"
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C Cloud services provides customers with the capabilities for building, deploying, and managing applications, services, and infrastructure in the Cloud. As a partner with the major Cloud providers, we utilize and administer Cloud platforms, such as Amazon Web Services (AWS), Microsoft Azure, and Google Cloud Platform (GCP), to rapidly and continuously develop and deploy applications and services for our customers’ systems and applications.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities',
          folder:'cloud',
          imageUrl: 'reduce-time.jpg',
          text: 'Reduce Delivery Time',
          hoverIcon: 'vector.png',
          hoverText: 'Reducing delivery schedules and costs by quickly scaling resources,  improving collaboration, leveraging CI/CD automation tools, and utilizing open technology'
        },{
          id: 1,
          subFolder:'capabilities',
          folder:'cloud',
          imageUrl: 'agility.jpg',
          text: 'Increase Agility',
          hoverIcon: 'chart.png',
          hoverText: 'Leveraging our Agile development approach and DevSecOps to continuously integrate and continuously deliver applications and services in the Cloud'
        },{
          id: 2,
          subFolder:'capabilities',  
          folder:'cloud',
          imageUrl: 'scalability.jpg',
          text: 'Improve Scalability and Reliability',
          hoverIcon: 'trend-down.png',
          hoverText: 'Minimizing unplanned downtime while improving scalability, flexibility and performance utilizing DevSecOps, Agile, and modern Cloud technology'
        },{
          id: 3,
          subFolder:'capabilities',  
          folder:'cloud',
          imageUrl: 'user-experience.jpg',
          text: 'Enhance the Human Experience',
          hoverIcon: 'lock.png',
          hoverText: 'Providing a human centered approach developing epics, performing business impact and value chain mapping, developing  stories, and use cases that enhance the human experience'
        }
      ],
      coreCapabilitiesItems: [
        {
          id: 4,
          subFolder:'capabilities', 
          folder:'cloud',
          imageUrl: 'aws-managed-services.jpg',
          text: 'AWS Managed Cloud Services',
          hoverIcon: 'analysis.png',
          hoverText: 'Provide customers with AWS Cloud capabilities for new applications, analytics, data lakes, generative AI, machine learning, low code/no code development, security, serverless computing, storage, and virtualization'
        },{
          id: 5,
          subFolder:'capabilities',
          folder:'cloud',
          imageUrl: 'azure-managed-services.jpg',
          text: 'Azure Managed Cloud Services',
          hoverIcon: 'inventory.png',
          hoverText: 'Build Azure OpenAI services and PowerBI applications, simplify the management of applications while ensuring high availability. Easily scale the environment, and automate system and application updates to improve security'
        },{
          id: 6,
          subFolder:'capabilities', 
          folder:'cloud',
          imageUrl: 'azure-managed-services.jpg',
          text: 'Cloud Migration',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Seamlessly migrate on premise applications and data to the Google, AWS or Azure Cloud, while providing continuous monitoring, support and optimization'
        },{
          id: 7,
          subFolder:'capabilities', 
          folder:'cloud',
          imageUrl: 'containerization.jpg',
          text: 'Containerization and Microservices',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Utilizes Docker, Azure Kubernetes Services (AKS), or Amazon Elastic Container Service (ECS) to develop Microservices, operate and run applications in a virtualized environment, and allowing for faster time-to-market.'
        },{
          id: 8,
          subFolder:'capabilities', 
          folder:'cloud',
          imageUrl: 'cloud storage.jpg',
          text: 'Cloud Storage and Data Security',
          hoverIcon: 'software-license.png',
          hoverText: 'Access data from anywhere, avoid physical storage costs, protect against data loss, provides automatic backup, and synchronization across devices, and significantly improves file and data sharing capability'
        },{
          id: 9,
          subFolder:'capabilities', 
          folder:'cloud',
          imageUrl: 'zero-trust.jpg',
          text: 'Zero Trust Cloud Architecture',
          hoverIcon: 'microservices.png',
          hoverText: 'Delivers next-generation managed services through our Cloud partnerships for cybersecurity, endpoint protection, and Governance, Risk and Compliance (GRC).'          
        }
      ],
      paragraphContent: `As a leading Cloud managed services provider with an exemplary track record, our team of experts continue to successfully leverage leading Cloud platform providers, optimizing customers’ systems and applications in the Cloud infrastructure, reducing on premise hardware and software costs, improving performance, reliability and scalability, and furthering innovation. As an industry leader, our customers’ rely on G14C Cloud services experts while they focus on their core business. Our delivery teams drive innovation by providing:<br><br>
        ● Best-in-Class Cloud DevSecOps Practices<br>
        ● Exceptional Cloud Engineering Capability<br>
        ● Human Centered Design Approach<br>
        ● Technology partnerships with AWS, Microsoft, and GCP
      `,
      sectionContents: [
        '“This contractor was instrumental in establishing the CMS’s Security Data Lake (SDL) using the Snowflake platform to perform Continuous Diagnostic and Monitoring (CDM) while integrating data sourced from AWS for a consolidated view of the security poster of all FISMA systems. G14C developed Lambda scripts, Snowpipes and consumed API services for data ingestion, and utilized the Agile Development Framework for establishing a CI/CD pipeline to design and develop and build the SDL in a Hybrid Cloud environment, while migrating several other applications to AWS.”',
        '“I am delighted to personally notify you that you have been selected as a member of the NITAAC Team to receive the OD Merit Honor Award. You are receiving this award for extraordinary service and leadership to the NIH and DHHS major IT acquisitions. Your efforts as a team and as individuals is exemplary and benefits the NIH. We will be sending you a letter formally notifying you of your award, and I wanted to take this opportunity to thank you for a job well done!"',
      ],
      additionalContent: [
        'CMS, COR', 
        'NIH, Deputy Director', 
      ],
      cardData: [
        {
          className: 'cloud',
          color: '#7594FE',
          heading: 'Application Modernization	',
          link: 'application-modernization'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'Cyber Security',
          link: 'cyber-security'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'DevSecOps',
          link: 'devsecops'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>